/*
 * @Author: liyang
 * @Date: 2021-04-07 15:57:42
 * @LastEditTime: 2023-08-03 11:34:25
 * @LastEditors: yuanxing(01407381)
 * @FilePath: \ibu-owt-core-frontend\middleware\router.js
 * @Description: 路由切换
 */
import { CountryLang } from '@/utils/constBase'
import { reachableCountry } from '@/utils/const'

export default function (context) {
  const { isHMR, route, redirect, $winstonLog } = context
  let { site, lang } = route.params
  if (isHMR) {
    return false
  }
  console.log('middleware is:', route.path)
  $winstonLog?.info(`middleware is: ${route.path}`)
  
  const reg = /(\/([a-z]{2})\/([a-z]{2}))(\/|$)/
  const siteLang = route.path.match(reg)
  const cossSite = ['ocss-site']

  // index.html 重定向
  if (/^.*index\.html$/.test(route.path)) {
    const link = route.path.replace(/^(.*)\/index\.html$/, '$1')
    return redirect({ statusCode: 200, path: link })
  }

  // 当访问不存在的路由时，site，lang为undefined
  if ((!site || !lang) && !cossSite.includes(site)) {
    // 使用正则匹配从路径中提取 site 和 lang
    if (siteLang && siteLang.length >= 4) {
      site = siteLang[2] // 第二个捕获组是 site
      lang = siteLang[3] // 第三个捕获组是 lang
      console.log('Extracted from path - site:', site, 'lang:', lang)
      $winstonLog?.info(`Extracted from path - site: ${site}, lang: ${lang}`)
    } else {
      // 如果无法从路径中提取，使用默认值
      console.log('Cannot extract site and lang from path, using defaults')
      $winstonLog?.info('Cannot extract site and lang from path, using defaults')
      return redirect({ statusCode: 404, path: '/cn/sc/error' })
    }
  }

  console.log('Final - site:', site, 'lang:', lang)
  $winstonLog?.info(`Final - site: ${site}, lang: ${lang}`)

  // 当前站点语言列表
  const curSiteLang = CountryLang[site]?.lang
  
  // 当不存在站点、语言时跳转自定义错误页面
  if (
    route.path !== '/404.html' &&
    (!reachableCountry[site] || !curSiteLang?.some((item) => item.code === lang)) &&
    !cossSite.includes(site)
  ) {
    console.log('not support site: ', site, lang)
    $winstonLog?.info(`not support site: ${site}, not support lang: ${lang}`)
    
    // 确保重定向路径有效
    const redirectPath = site && lang ? `/${site}/${lang}/error` : '/cn/sc/error'
    return redirect({ statusCode: 404, path: redirectPath })
  }
}